import {Component, HostBinding, HostListener, Input, OnInit} from '@angular/core';
import {FolderComponentObject} from '../../../shared/classes/folder-component-object';
import {showOpacityAnimation} from '../../../shared/animations/show-opacity.animation';
import {SavedReportPageStore} from '../../../shared/store/savedReportsPage/savedReportPage.store';

@Component({
  selector: 'app-parent-folder-card',
  templateUrl: './parent-folder-card.component.html',
  styleUrls: ['./parent-folder-card.component.scss'],
  animations: [
    showOpacityAnimation
  ]
})
export class ParentFolderCardComponent implements OnInit {
  @Input("folder") public folder: FolderComponentObject;

  constructor(
    private readonly _savedReportPageStore: SavedReportPageStore
  ) { }

  ngOnInit(): void {
  }

  public selectFolder(): void {
    this._savedReportPageStore.selectFolder(this.folder);
  }

  @HostBinding('@showOpacity') get showOpacity() {
    return 'show';
  }

  @HostListener('click', ['$event']) public click(): void {
    this.selectFolder();
  }
}
